import { render, staticRenderFns } from "./RoleViewPage.vue?vue&type=template&id=aaf63d3e&scoped=true&"
import script from "./RoleViewPage.vue?vue&type=script&lang=js&"
export * from "./RoleViewPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaf63d3e",
  null
  
)

export default component.exports